// extracted by css-extract-rspack-plugin
export default {"cls1":"CoScientistLandingPage-cls1_8T8","cls2":"CoScientistLandingPage-cls2_UhQ CoScientistLandingPage-cls1_8T8"};